import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid nav-bar bg-transparent" }
const _hoisted_2 = { class: "navbar navbar-expand-lg bg-white navbar-light py-0 px-4" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navbarCollapse"
}
const _hoisted_4 = { class: "navbar-nav ms-auto" }
const _hoisted_5 = { class: "nav-item dropdown" }
const _hoisted_6 = { class: "dropdown-menu rounded-0 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navbar-brand d-flex align-items-center text-center"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "icon p-2 me-2" }, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: "/img/real-estate.png",
              alt: "Icon",
              style: {"width":"30px","height":"30px"}
            })
          ], -1),
          _createElementVNode("h1", { class: "m-0 text-primary" }, "Estate Rwanda", -1)
        ])),
        _: 1,
        __: [0]
      }),
      _cache[9] || (_cache[9] = _createElementVNode("button", {
        type: "button",
        class: "navbar-toggler",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarCollapse"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: _normalizeClass(["nav-item nav-link", { active: _ctx.currentRoute === '/' }])
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Home", -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["class"]),
          _createVNode(_component_router_link, {
            to: "/about",
            class: _normalizeClass(["nav-item nav-link", { active: _ctx.currentRoute === '/about' }])
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("About", -1)
            ])),
            _: 1,
            __: [2]
          }, 8, ["class"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/properties",
              class: _normalizeClass(["nav-link dropdown-toggle", { active: _ctx.currentRoute.startsWith('/properties') || _ctx.propertyRoutes.includes(_ctx.currentRoute) }]),
              "data-bs-toggle": "dropdown"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Property", -1)
              ])),
              _: 1,
              __: [3]
            }, 8, ["class"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/buy-properties",
                class: "dropdown-item"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Buy", -1)
                ])),
                _: 1,
                __: [4]
              }),
              _createVNode(_component_router_link, {
                to: "/rent-properties",
                class: "dropdown-item"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Rent", -1)
                ])),
                _: 1,
                __: [5]
              }),
              _createVNode(_component_router_link, {
                to: "/property-list",
                class: "dropdown-item"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Property List", -1)
                ])),
                _: 1,
                __: [6]
              })
            ])
          ]),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: _normalizeClass(["nav-item nav-link", { active: _ctx.currentRoute === '/contact' }])
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Contact", -1)
            ])),
            _: 1,
            __: [7]
          }, 8, ["class"])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("a", {
          href: "https://agents.estaterwanda.com/",
          class: "btn btn-primary px-3 d-none d-lg-flex"
        }, "Add Property", -1))
      ])
    ])
  ]))
}